import React, { useEffect, useMemo, useState } from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { toast } from 'react-toastify'
import { ChargePerReelSocialAccount } from '../../types/layout/layoutTypes'
import { updateChargePerReel } from '../../services/api/influencer'
import { getErrorMessage } from '../../utils/helpers'

const ChargePerReelModal: React.FC<{
    isActive: boolean
    socialAccount?: ChargePerReelSocialAccount
    prefill?: number
    onClose: () => void
}> = ({ isActive, socialAccount, prefill, onClose }) => {
    const [amount, setAmount] = useState('')
    const [status, setStatus] = useState<'IDLE' | 'PENDING'>('IDLE')

    useEffect(() => {
        if (isActive) {
            setAmount(prefill && prefill > 0 ? String(prefill) : '')
            setStatus('IDLE')
        }
    }, [isActive, prefill, socialAccount?.uuid])

    const amountValue = useMemo(() => Number(amount), [amount])
    const isValidAmount = useMemo(
        () => amount !== '' && Number.isInteger(amountValue) && amountValue > 0,
        [amount, amountValue]
    )

    const handleSubmit = async () => {
        if (!isValidAmount || !socialAccount) {
            toast.error('Please enter a valid amount')
            return
        }

        try {
            setStatus('PENDING')
            await updateChargePerReel(socialAccount?.uuid ?? '', amountValue)
            toast.success('Submitted - thanks for sharing!')
            onClose()
        } catch (error) {
            toast.error(getErrorMessage(error, 'Failed to save your reel rate. Please try again.'))
        } finally {
            setStatus('IDLE')
        }
    }

    if (!socialAccount) return null;

    return (
        <div className='campaign-apply-confirmation scrollable-modal-body p-0'>
            <div className="d-flex flex-column gap-2 p-3">
                <div className="form-group gap-2 d-flex flex-column mb-3">
                    <div className="d-flex gap-2">
                        <img
                            src={(socialAccount.profile_picture_url ?? '').split('=')[0]}
                            alt=""
                            className='rounded-sm'
                            width={50}
                            height={50}
                        />
                        <div className="d-flex flex-column">
                            <label htmlFor="">Collaboration rate for</label>
                            <span className='text-dark fs-16 fw-500'>{socialAccount.handle}</span>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column gap-2">
                    <label htmlFor="charge-per-reel-amount" className='text-dark fs-12 fw-400 m-0'>ENTER YOUR AMOUNT</label>
                    <input
                        id="charge-per-reel-amount"
                        className='campaign-negotiation-amount-input'
                        type="text"
                        inputMode="numeric"
                        value={amount}
                        placeholder="Ex. ₹2,500"
                        onChange={(event) => setAmount(event.target.value.replace(/\D/g, ''))}
                    />
                </div>

                <p className="text-secondary fs-12 fw-400 mb-0 mt-2">
                    <span className="fw-bold">NOTE: </span>
                    We'll use this to recommend campaigns that better match your typical pricing.
                </p>
            </div>

            <div className="campaign-apply-ig-connect-benefit-actions scrollable-modal-footer">
                <div className='px-3'>
                    <button
                        onClick={handleSubmit}
                        disabled={status === 'PENDING' || !isValidAmount}
                        className="btn btn-primary w-100"
                    >
                        {status === 'PENDING' ? 'Submitting...' : 'Submit'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default withSlideUpModal(
    ChargePerReelModal,
    'Share what you typically charge for a brand collaboration reel.',
    true
)
